import { render, staticRenderFns } from "./UiMain.vue?vue&type=template&id=747a4062&scoped=true"
import script from "./UiMain.vue?vue&type=script&lang=js"
export * from "./UiMain.vue?vue&type=script&lang=js"
import style0 from "./UiMain.vue?vue&type=style&index=0&id=747a4062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747a4062",
  null
  
)

export default component.exports